import { render, staticRenderFns } from "./eulogysItem.vue?vue&type=template&id=05d52cfc&scoped=true"
import script from "./eulogysItem.vue?vue&type=script&lang=js"
export * from "./eulogysItem.vue?vue&type=script&lang=js"
import style0 from "./eulogysItem.vue?vue&type=style&index=0&id=05d52cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d52cfc",
  null
  
)

export default component.exports